import { render, staticRenderFns } from "./addUserBlack.vue?vue&type=template&id=47d4d72a&scoped=true&"
import script from "./addUserBlack.vue?vue&type=script&lang=js&"
export * from "./addUserBlack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d4d72a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47d4d72a')) {
      api.createRecord('47d4d72a', component.options)
    } else {
      api.reload('47d4d72a', component.options)
    }
    module.hot.accept("./addUserBlack.vue?vue&type=template&id=47d4d72a&scoped=true&", function () {
      api.rerender('47d4d72a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userManagement/addUserBlack.vue"
export default component.exports